import Icon from 'components/icon/Icon';
import Link from 'components/link/Link';

import { IEventPageLink } from 'source/NFR.types';

import { EventPageLink_IconMap, getEnumStringValue } from 'js/utils/enum-string-maps';

const EventPageLink: React.FC<IEventPageLink> = ({ icon, text, url }) => {
  if (!url) return null;
  return (
    <div className="event-page-link">
      <div className="event-page-link--icon">
        <Icon name={getEnumStringValue(EventPageLink_IconMap, icon) || ''} fill />
      </div>
      <Link url={url} text={text} />
    </div>
  );
};

EventPageLink.displayName = 'EventPageLink';

export default EventPageLink;
